import { dates, objects, validators } from 'investira.sdk';

/** Filtra uma série a partir de uma quantidade de meses relativa à data de referência. */
export const filtrarHistoricoPorPeriodo = (pDados, pMeses, pDataRef = dates.toDate()) => {
  const xDataLimite = dates.toSqlDate(dates.addMonths(pDataRef, pMeses));

  return pDados.filter(xItem => dates.toSqlDate(new Date(xItem.data)) >= xDataLimite);
};

/** Ordena e filtra uma série a partir de uma data específica. */
export const filtrarHistoricoPorData = (pDados, pDataEspecifica) => {
  const xData = new Date(pDataEspecifica);

  return pDados
    .sort((pPrimeiro, pSegundo) => new Date(pPrimeiro.data) - new Date(pSegundo.data))
    .filter(xItem => new Date(xItem.data) >= xData);
};

/** Calcula a diferença percentual preservando a fórmula histórica do produto. */
export const calcularVariacaoPercentual = (pValorInicial, pValorFinal) => {
  if (pValorInicial === 0) {
    return pValorFinal === 0 ? 0 : Infinity;
  }

  return (pValorInicial / pValorFinal - 1) * 100;
};

/** Calcula a diferença entre as extremidades de um período. */
export const calcularDiffNoPeriodo = (pDadosFiltrados, pKey = 'cotacao_ajustada') => {
  if (pDadosFiltrados.length < 2) return null;

  const xCotacaoInicial = pDadosFiltrados[pDadosFiltrados.length - 1][pKey];
  const xCotacaoFinal = pDadosFiltrados[0][pKey];
  const xResult = calcularVariacaoPercentual(xCotacaoInicial, xCotacaoFinal);

  return isNaN(xResult) || xResult === Infinity ? null : xResult;
};

/** Adiciona a rentabilidade acumulada a uma cópia da série recebida. */
export const adicionarRentabilidade = pData => {
  const xData = objects.deepCopy([...pData]);

  if (xData.length < 2) return pData;

  let xRentabilidade = 1;
  xData[0].rentabilidade = 0;

  for (let xIndex = 1; xIndex < xData.length; xIndex += 1) {
    xRentabilidade *= xData[xIndex].variacao_diaria;
    xData[xIndex].rentabilidade = (xRentabilidade - 1) * 100;
  }

  return xData;
};

/** Cria as janelas históricas padronizadas usadas pelos ativos. */
export const criarHistorico = (pData, pDataCorte) => {
  const xHoje = new Date();
  const xPrimeiraDataAno = new Date(xHoje.getFullYear(), 0, 1);
  let xData = pData;

  if (!validators.isNull(pDataCorte)) {
    xData = filtrarHistoricoPorData(xData, pDataCorte);
  }

  return {
    ytd: adicionarRentabilidade(filtrarHistoricoPorData(xData, xPrimeiraDataAno)),
    umMes: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -1)),
    seisMeses: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -6)),
    umAno: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -12)),
    doisAnos: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -24)),
    tresAnos: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -36)),
    quatroAnos: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -48)),
    cincoAnos: adicionarRentabilidade(filtrarHistoricoPorPeriodo(xData, -60)),
    full: adicionarRentabilidade(xData)
  };
};
